import { defineMessages } from "react-intl";

export default defineMessages({
  bancontact: {
    id: "paymentMethods.bancontact",
    defaultMessage: "Bancontact",
  },
  noBancontact: {
    id: "paymentMethods.noBancontact",
    defaultMessage: "No Bancontact",
  },
  bancontactTransactionsAreNotSupportedForThisService: {
    id: "paymentMethods.bancontactTransactionsAreNotSupportedForThisService",
    defaultMessage:
      "Bancontact transactions are not supported for this service",
  },
});
